export const types = {
  /* AUTENTICACIÓN */
  login: "[Auth] Login",
  signup: "[Auth] Signup",
  logout: "[Auth] Logout",

  /* MOVIES */
  get: "[Movie] Get Movie",
  detail: "[Movie] Detail Movie",
  search: "[Movie] Search Movie",

  /* USERS */
  getUsers: "[Crud] Get Users",
  addUser: "[Crud] Add User",
  updateUser: "[Crud] Update User",
  deleteUser: "[Crud] Delete User",
};
